<template>
    <div class="accordion-item rounded-sm" :class="[{'border': border}, paddingParentClass]">
        <div class="flex accordion-item-header items-center cursor-pointer" @click="toggleContent">
            <slot v-if="$slots.header" name="header"></slot>
            <template v-else>
                <div class="accordion-item-header-icon mr-16" v-if="icon">
                    <svg-icon :type="icon" class="w-16 h-16" :class="['text-' + iconColor]"/>
                </div>
                <div>
                <span class="font-semibold text-primary capitalize">
                    {{ title }}
                </span>
                    <p v-if="description">
                        {{ description }}
                    </p>
                </div>
            </template>
            <div class="accordion-arrow" :class="{'ms-auto': chevronAlignment === 'right'}">
                <svg-icon type="keyboard-arrow-down" class="w-24 h-24"/>
            </div>
        </div>
        <div ref="accordion-item-body"
             class="accordion-item-body relative overflow-hidden"
             :class="[(isOpen ? 'max-h-fit mt-20 ' + paddingContentClass : 'max-h-0'), contentClasses]"
        >
            <slot name="content"></slot>
        </div>
    </div>
</template>

<script>
import SvgIcon from './SvgIcon.vue';

export default {
    name: "accordion-item",
    components: {
        SvgIcon
    },
    props: {
        title: {
            type: String,
            required: true
        },
        description: {
            type: String,
        },
        icon: {
            type: String,
            required: false
        },
        iconColor: {
            type: String,
            default: 'blue-600',
        },
        border: {
            type: Boolean,
            default: true,
        },
        chevronAlignment: {
            type: String,
            default: 'right',
            validator: value => ['right', 'left'].includes(value),
        },
        padding: {
            type: String,
            default: 'medium',
            validator: value => ['small', 'medium', 'large', 'none'].includes(value),
        },
        contentClasses: {
            type: String,
            default: '',
        }
    },
    data() {
        return {
            isOpen: false,
        }
    },
    computed: {
        paddingParentClass() {
            switch (this.padding) {
                case 'small':
                    return 'px-8 py-4';
                case 'medium':
                    return 'px-16 py-8';
                case 'large':
                    return 'px-32 py-16';
                case 'none':
                    return 'p-0';
            }
        },
        paddingContentClass() {
            switch (this.padding) {
                case 'small':
                    return 'px-8 pb-16';
                case 'medium':
                    return 'px-32 pb-48';
                case 'large':
                    return 'px-32 pb-48';
                case 'none':
                    return 'ps-10 p-0';
            }
        },
    },
    methods: {
        toggleContent(event) {
            const target = event.currentTarget;
            let content = this.$refs['accordion-item-body'];

            target.querySelector('.accordion-arrow svg').classList.toggle('rotate-180');
            this.isOpen = !this.isOpen;
        }
    }
}
</script>

<style scoped>

</style>
